/**
 * Created by rak on 30/06/2016.
 */

'use strict';

angular.module('dashboard.driverWrkHrsDashboard', ['adf.provider'])
  .config(function (dashboardProvider) {
    dashboardProvider
      .widget('DriverWrkHrsWidget', {
        resolve: {
          title: function () {
            return 'dashBoard.fleetManagement.driverWorkingHours.driverWrkHoursList';
          },
          description: function () {
            return 'dashBoard.fleetManagement.driverWorkingHours.description';
          }
        },
        controller: 'DriverWrkHrsListCtrl',
        templateUrl: 'components/dashboard/driverWorkingHours/driverWorkingHoursWidget.tpl.html',
        isSingleInstance: true,
        reload: true,
        config: {
          vehicleGroup: null,
          noOfGridRows: ''
        },
        edit: {
          templateUrl: 'components/dashboard/driverWorkingHours/driverWorkingHoursWidgetEdit.tpl.html',
          reload: false,
          controller: 'DriverWorkingHoursEditCtrl'
        }
      });
  }).service('DriverWrkHrsWidgetService', function (crudService) {

    this.getDriverWorkingHrsList = function (vechileGroup, isDataRefresh, reportOption) {
      var requestParam = {
        statusCode: 'all',
        vehicleGroup: vechileGroup,
        reportOption: reportOption || '',
        dataRefresh: isDataRefresh,
        timeTo: '-0d',
        timeFrom: ''
      };
      var param = {
        'filter': JSON.stringify(requestParam)
      };
      return crudService.customGET('driverdashboard', '', param);
    };
    this.getDriverWorkingHoursListForDevice = function (deviceId) {
      var requestParam = {
        deviceid: deviceId,
        dataRefresh: false,
        timeTo: '-0d',
        timeFrom: ''
      };
      var param = {
        'filter': JSON.stringify(requestParam)
      };
      return crudService.customGET('driverdashboard/' + deviceId, '', param);
    };

    this.getCurrentDriverWorkingHoursRepOptions = function () {
      return crudService.get('vehicledetailsreport/options/currentdaydriverworkinghours');
    };

  }).controller('DriverWrkHrsListCtrl', function ($scope, config, widgetSettingsCreatorService, stateManagerService, vehicleListWidgetService, DriverWrkHrsWidgetService, $rootScope, $timeout, $q, $translate, commonTrackService, $filter, AuthenticationService, localStorageService, $state, errorHandlingService, $interval) {
    $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
    $scope.selectedFunction = '';
    $scope.isDataAvailable = true;
    $scope.planReportList = [1, 2];
    var _lastRefreshTimeS = null;
    //var lastlocationWidgetData = commonTrackService.getsetLastLocatioWidgetData();
    var counterSeconds = 60;
    var counterTimeout;
    var rowSize = vehicleListWidgetService.getRowSize();
    var workingHoursListSource =
    {
      datatype: 'array',
      datafields: [],
      localdata: [],
      sort: null
    };
    var dvrWrkhrsContextMenu = {};
    var isdvrWrkhrsCtxInitialized = false;


    /**
     *  temporay private variable  to store some global values , created to avoid using config object .
     *  dont use config which will be stored to localstorage and may cuase issues when reused from localstorage
     */
     var _tmpConfig ={};

    $scope.vehicleGroupSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'description',
      valueMember: 'groupID',
      //theme: 'material' use default theme instead
    });

    $scope.cDayDriverWorkHoursRepOptions = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'displayName',
      valueMember: 'key'
    });


    $scope.customGridProperties = {
      vehicleLastLocation: {
        height: config.noOfGridRows ? rowSize[config.noOfGridRows] - 15 : 455,
        pageable: false,
        columns: []
      }
    };

    $scope.moreFuctionSetting = vehicleListWidgetService.getMoreFunctionSettings();
    $scope.uuidForElement =  $scope.$id;


    var loadVehicleGroup = function () {
      return commonTrackService.getVehicleGroupComboList().then(function (vechileGroupList) {
        if (vechileGroupList.length > 0) {
          $scope.vehicleGroupSettings.source = vechileGroupList;
          var cachedGroup = commonTrackService.getCachedVehicleGroup(vechileGroupList);

          if (commonTrackService.isLocalOrconfigVehicleGroupValid(vechileGroupList, config.vehicleGroup)) { // validate the local storage group is still valid ( group can change based on login )
            $scope.vehicleGroup = config.vehicleGroup;
          }

          if (!config.vehicleGroup || cachedGroup !== config.vehicleGroup) {
            if (commonTrackService.isLocalOrconfigVehicleGroupValid(vechileGroupList, cachedGroup)) {// validate the local storage group is still valid ( group can change based on login )
              $scope.vehicleGroup = cachedGroup;
              config.vehicleGroup = cachedGroup;
            }
          }
          if (!$scope.vehicleGroup) {
            $scope.vehicleGroup = vechileGroupList[0].groupID;
          }
        }
      });
    };
    var loadFleetServerDetails = function () {
      return commonTrackService.getFleetServerDetails().then(function (fleetServerDetails) {
        $scope.fleetServerUrl = fleetServerDetails.qualifiedServerURL;
      });
    };

    var loadWorkingHours = function (vehicleGroup, dataRefresh, reportOption, isAutorefresh) {
      $scope.stop();
      return DriverWrkHrsWidgetService.getDriverWorkingHrsList(vehicleGroup, dataRefresh, reportOption).then(function (workingHoursList) {
        if (workingHoursList.dataList) {
          $scope.isDataAvailable = true;
          if (dataRefresh) {
            $scope.customGridProperties.vehicleLastLocation.columns = commonTrackService.getColumnProperties(workingHoursList.gridSettings.overviewListGrids[0].columnProperties, workingHoursList.columnTranslation, { moduleName: 'cDayDriverWorkingHoursDB' });
            var _additionalProperties = { translatedName: $translate.instant('dashBoard.fleetManagement.driverWorkingHours.driverWrkHoursList') };
            $scope.cDayDrvrWrkHoursGridSettings = commonTrackService.getGridSettings('cDayDriverWorkingHoursDB', $scope.customGridProperties.vehicleLastLocation, null, _additionalProperties);
            $scope.cDayDrvrWrkHoursGridSettings.columngroups = commonTrackService.createColumnGroups(workingHoursList.gridSettings.overviewListGrids[0].columnGroupProperties, 'cDayDriverWorkingHours');
            workingHoursListSource.sort = commonTrackService.getCustomSortFunction($scope.overviewGridPrefix + 'cDayDriverWorkingHoursDBList', workingHoursListSource);
            workingHoursListSource.localdata = workingHoursList.dataList;
            _lastRefreshTimeS = workingHoursList.dataCreationTimeSeconds;
            $scope.workingHoursListdataAdapter = new $.jqx.dataAdapter(workingHoursListSource);
            $scope.cDayDrvrWrkHoursGridSettings.source = $scope.workingHoursListdataAdapter;
          }
          else {
            workingHoursListSource.localdata = workingHoursList.dataList;
            _lastRefreshTimeS = workingHoursList.dataCreationTimeSeconds;
            commonTrackService.updateBoundData($scope.overviewGridPrefix + 'cDayDriverWorkingHoursDBList');
          }
        }

      }, function (response) {
        if (errorHandlingService.errorForNoAuthorized(response)) {
          $rootScope.$broadcast('rest-error-event', response);
          $scope.isDataAvailable = false;
        }
      }).finally(function () {
        $scope.counter = counterSeconds;
        if (($scope.isDataAvailable && !counterTimeout) || ($scope.isDataAvailable && counterTimeout.$$state && counterTimeout.$$state.value === 'canceled')) {
          $scope.startCounter();
        } else {
          $scope.stop();
        }


        if (isAutorefresh && _lastWrhrsSelectedRowIndex || !dataRefresh && _lastWrhrsSelectedRowIndex || _lastWrhrsSelectedRowIndex === 0) {
          $timeout(function () {
            var rows = $('#' + $scope.overviewGridPrefix + 'cDayDriverWorkingHoursDBList').jqxGrid('getrows');
            _lastWrhrsSelectedRowIndex = commonTrackService.getSelectRowIndexByCache(rows);
            if (_lastWrhrsSelectedRowIndex < 0) {
              broadcastEventData.selectedRow = null;
              broadcastEventData.dashboardName = 'dashboard.driverWrkHrsDashboard';
              broadcastEventData.isDataFromTab = true;
              broadcastEventData.tabNumber = 0;
              broadcastEventData.isTermoWidgetDependent = true; // SCL-1496
              $rootScope.$broadcast('rowSelected', broadcastEventData);
              return;
            }
            $('#' + $scope.overviewGridPrefix + 'cDayDriverWorkingHoursDBList').jqxGrid('selectrow', _lastWrhrsSelectedRowIndex);
          }, 0);
        }
        $scope.createCdayDrvrWrkHours = true;
      });
    };

    var loadDashboardReportOption = function () {
      return DriverWrkHrsWidgetService.getCurrentDriverWorkingHoursRepOptions().then(function (repOptons) {
        for (var i = 0; i < repOptons.length; i++) {
          repOptons[i].displayName = $translate.instant('dashBoard.fleetManagement.driverWorkingHours.workingHoursType.' + repOptons[i].key);
        }
        $scope.cDayDriverWorkHoursRepOptions.source = repOptons;
        var loginid = AuthenticationService.GetLoginID();
        var reportOpt = localStorageService.get('driverWorkingHour.reportOption.' + loginid.Account + '.' + loginid.username);
        if (reportOpt) {
          $scope.dwrkHrsRepOption = reportOpt;
          _tmpConfig.lastSelectedOption = reportOpt;
        } else {
          $scope.dwrkHrsRepOption = repOptons[0].key;
          _tmpConfig.lastSelectedOption = repOptons[0].key;
        }
      });

    };

    function createMessageEvent() {
      $rootScope.$broadcast('newMsgEvent', {});
    }

    function createCommandEvent() {
      $rootScope.$broadcast('newCommandEvent', {});
    }

    function showDashboard() {
      $state.go('betotrack.dashboard');
    }

    /*function showPortalCommand() {
      $state.go('portalcommand');
    }
  */
    function showFmsDashboard() {
      $state.go('fmsdashboard');
    }

    var _commonFunction = {
      'createMessageEvent': createMessageEvent,
      'createCommandEvent': createCommandEvent,
    };

    var _contextSourceObj = {
      dvrWrkhrsCtxSource: [
        {
          label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendMsg'),
          execute: createMessageEvent
        },
        {
          label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendCommand'),
          execute: createCommandEvent
        },
        {
          label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showDashboard'),
          execute: showDashboard
        }, /*{
        label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showPortalCommand'),
        execute: showPortalCommand
      },*/
        {
          label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showFmsDashboard'),
          execute: showFmsDashboard
        }
      ]
    };

    $scope.ctxMenuSettings = vehicleListWidgetService.getContextMenuSettings(110);
    $scope.ctxMenuSettings = _.extend($scope.ctxMenuSettings, {
      source: _contextSourceObj.dvrWrkhrsCtxSource, popupZIndex: 999999
    });
    loadVehicleGroup().then(function () {
      return loadDashboardReportOption();
    }).then(function () {
      return loadFleetServerDetails();
    }).finally(function () {
      $scope.dataLoadingFinished = true;
      if ($scope.vehicleGroup) {
        loadWorkingHours($scope.vehicleGroup, true, $scope.dwrkHrsRepOption);
      }

    });

    var broadcastEventData = {
      selectedRow: {},
      selectedVehicleGroup: '',
      selectedVehicleGroupLabel: '',
      eventSource: ''
    };

    var _lastWrhrsSelectedRowIndex = null;

    $scope.vehicleGroupComboChange = function (event) {
      var vehicleGroup = event.args.item;
      // var statusCode = $('#statusCodeComboBox').jqxComboBox('getSelectedItem');
      if (config.vehicleGroup !== vehicleGroup.value && $scope.cDayDrvrWrkHoursGridSettings && $scope.cDayDrvrWrkHoursGridSettings.columns) {
        loadWorkingHours(vehicleGroup.value, $scope.cDayDrvrWrkHoursGridSettings.columns.length > 0 ? false : true, $scope.dwrkHrsRepOption);
        var loginid = AuthenticationService.GetLoginID();
        localStorageService.set('selected_vehicleGroup.' + loginid.Account + '.' + loginid.username, vehicleGroup.value);
      }
      if (vehicleGroup) {
        commonTrackService.setLastSelectedGroup(vehicleGroup);
        config.vehicleGroup = vehicleGroup.value;
        broadcastEventData.selectedVehicleGroup = vehicleGroup.value;
        broadcastEventData.selectedVehicleGroupLabel = vehicleGroup.label;
        broadcastEventData.dashboardName = 'dashboard.driverWrkHrsDashboard';
        broadcastEventData.isDataFromTab = true;
        broadcastEventData.tabNumber = 0;
        $rootScope.$broadcast('vehicleGroupChanged', broadcastEventData);
      }

    };
    // update vehicle map widget  based on selected vechile id
    $scope.cDayDriverWorkingHoursSelectHandler = function (event) {
      if (event.type === 'rowselect' && event.args.row) {
        _lastWrhrsSelectedRowIndex = event.args.rowindex;
        broadcastEventData.selectedRow = event.args.row;
        commonTrackService.setLastLocatioWidgetData(broadcastEventData);
        var pushPinIndex = event.args.row.index - 1;
        $rootScope.$broadcast('fleet-map-update', { pushPinIndex: pushPinIndex, deviceId: event.args.row.deviceid });
        commonTrackService.setDriverDashboardLastSelectedRowData(broadcastEventData);
        $rootScope.$broadcast('init-widget-data-from-server', { deviceID: event.args.row.deviceid, selectedRow: event.args.row });


        broadcastEventData.dashboardName = 'dashboard.driverWrkHrsDashboard';
        broadcastEventData.isDataFromTab = true;
        broadcastEventData.tabNumber = 0;
        broadcastEventData.isTermoWidgetDependent = true; // SCL-1496
        $rootScope.$broadcast('rowSelected', broadcastEventData);

        stateManagerService.updateValue('driverWrkHrsWidget', 'deviceID', broadcastEventData.selectedRow.deviceid, true);
        stateManagerService.updateValue('driverWrkHrsWidget', 'driverID', broadcastEventData.selectedRow.driverid, true);
        stateManagerService.updateValue('driverWrkHrsWidget', 'rowData', broadcastEventData.selectedRow, false); // OUT dated ?
        if (!_.isEmpty(broadcastEventData.selectedRow)) {
          stateManagerService.updateValue('driverWrkHrsWidget', 'tab_0_selectedRow', broadcastEventData.selectedRow, true);
        }
        $rootScope.$broadcast('dataStateUpdate', {
          widget: 'driverWrkHrsWidget', activeTab: 0,
          dashboardName: 'dashboard.driverWrkHrsDashboard',
        });

        var loginid = AuthenticationService.GetLoginID();
        localStorageService.set('selected_vehicle.' + loginid.Account + '.' + loginid.username, {
          'deviceid': broadcastEventData.selectedRow.deviceid,
          'driverid': broadcastEventData.selectedRow.driverid
        });
      }
    };

    $scope.gridRowClickHandler = function (event) {
      if (event.args.rightclick) {
        if (!isdvrWrkhrsCtxInitialized) {
          dvrWrkhrsContextMenu = $('#'+$scope.uuidForElement+'_betoTrack_cDayDriverWorkingHoursDBCtx').jqxMenu($scope.ctxMenuSettings);
          $('#'+$scope.uuidForElement+'_betoTrack_cDayDriverWorkingHoursDBCtx').on('itemclick', dvrWrkhrsContextHandler);
          isdvrWrkhrsCtxInitialized = true;
        }
        commonTrackService.initGridRightClickContextMenu(event, dvrWrkhrsContextMenu);
      }
    };

    function dvrWrkhrsContextHandler(event) {
      commonTrackService.executeContextMenuClick(event, 'dvrWrkhrsCtxSource', _contextSourceObj);
    }

    $scope.startCounter = function () {
      $scope.stop();
      $scope.isTimerStated = true;
      $scope.timerDesc = $translate.instant('dashBoard.fleetManagement.vehicleList.stopAutoUpdate');
      if ($scope.counter - 1 >= 1) {
        $scope.counter--;
        counterTimeout = $interval($scope.startCounter, 1000);
      } else {
        loadWorkingHours(config.vehicleGroup, false, $scope.dwrkHrsRepOption, true);
      }
    };


    $scope.stop = function () {
      $interval.cancel(counterTimeout);
    };

    $scope.moreFunctionsOnChange = function (event) {
      if (event.args.item.value === 'showReport') {
        var _objNameParam = event.args.item.originalItem.execute.split('-');
        _commonFunction[_objNameParam[0]](_objNameParam[1]);
      } else {
        if (event.args.item.originalItem.execute) {
          _commonFunction[event.args.item.originalItem.execute]();
        }
      }
      $('#moreFunDropDown').jqxDropDownList('clearSelection');
      $('#ordersMoreFunction').jqxDropDownList('clearSelection');
    };
    $scope.driverWrksListComboChange = function (event) {
      if (!event.args) {
        return;
      }
      var reportOption = event.args.item;

      var loginid = AuthenticationService.GetLoginID();
      localStorageService.set('driverWorkingHour.reportOption.' + loginid.Account + '.' + loginid.username, reportOption.value);

      if (reportOption && _tmpConfig.lastSelectedOption !== reportOption.value) {
        _tmpConfig.lastSelectedOption = reportOption.value;
        $scope.dwrkHrsRepOption = reportOption.value;
        loadWorkingHours(config.vehicleGroup, false, reportOption.value);
      }


    };

    $scope.stopAutoRefresh = commonTrackService.getRefreshStartStopfunction($scope, true, true, loadWorkingHours, 'vehicleGroupComboBox', false, 'cDayDriverWorkHoursRepOptionsComboBox');

    //job-vent listener
    var jobEvent = $scope.$on('job-event', function (event, data) {
      var _eventDateTime = new Date(data.eventTimeStamp * 1000);
      var _gridRefreshDateTime = new Date(_lastRefreshTimeS * 1000);
      //console.log('data.eventTimeStamp - ' + _eventDateTime);
      //console.log('grid refresh time - ' + _gridRefreshDateTime);
      // console.log(_eventDateTime > _gridRefreshDateTime);
      if (_eventDateTime > _gridRefreshDateTime) {
        var _tmpGridsource = workingHoursListSource.localdata;
        for (var i = 0; i < _tmpGridsource.length; i++) {
          if (_tmpGridsource[i].deviceid === data.dev) {
            _tmpGridsource[i].lastjobstatusdesc = data.statusdescription;
            _tmpGridsource[i].lastjobstatusdescColor = data.statusdescFgColor;
            _tmpGridsource[i].lastjobstatusdescBgColor = data.statusdescBgColor;
            _tmpGridsource[i].driverdesc = data.driverdesc !== null ? data.driverdesc : '';
            _tmpGridsource[i].date = $filter('date')(_eventDateTime, 'dd/MM/yyyy');
            _tmpGridsource[i].time = $filter('date')(_eventDateTime, 'HH:mm:ss');
            $scope.cDayDrvrWrkHoursGridSettings.source = _tmpGridsource;
            $('#' + $scope.overviewGridPrefix + 'cDayDriverWorkingHoursDBList').jqxGrid('updatebounddata', 'data');
            break;
          }
        }
      }
    });

    $scope._iniDriverWorkHrsTab = function () {
      if (counterTimeout.$$state.value === 'canceled') {
        $scope.stop();
        $scope.stopAutoRefresh(null, 'start');
      }
    };

    var currentSelectedRowReqEvent = $scope.$on('vehicleMap_req_current_context', function () {
      $rootScope.$broadcast('vehicleMap_res_current_context', {
        dashboardName: 'dashboard.driverWrkHrsDashboard',
        isDataFromTab: true,
        tabNumber: 0,
        currentWidgetContextData: broadcastEventData,
        dataLoadingFinished: $scope.dataLoadingFinished,
        isDataAvailable: $scope.isDataAvailable
      });
    });

    var currentSelectedGroupEvent = $scope.$on('fleetMap_req_current_context', function () {
      $rootScope.$broadcast('fleetMap_res_current_context', {
        dashboardName: 'dashboard.driverWrkHrsDashboard',
        vehicleGroup: config.vehicleGroup
      });
    });
    // stateManagerService
    // Used when unkown dependant (child) widget requests data.
    // Since this is a global request for data, widget needs to check if the,
    // requested fields is anything it can provide before updating.
    // Will call the dataStateUpdate event if it updates data.
    var updateRequest = $scope.$on('reqDataUpdate', function () {
      var selectedRowData = {};
      var selectIndex = -1;

      selectIndex = window.$('#' + $scope.overviewGridPrefix + 'cDayDriverWorkingHoursDBList').jqxGrid('getselectedrowindex');
      if (selectIndex > -1) {
        selectedRowData = window.$('#' + $scope.overviewGridPrefix + 'cDayDriverWorkingHoursDBList').jqxGrid('getrowdata', selectIndex);
      }
      // push the changes to stateManagerService
      stateManagerService.updateValue('driverWrkHrsWidget', 'deviceID', selectedRowData.deviceid, true);
      stateManagerService.updateValue('driverWrkHrsWidget', 'driverID', selectedRowData.driverid, true);

      stateManagerService.updateValue('driverWrkHrsWidget', 'tab_0_selectedRow', selectedRowData, true);

      $rootScope.$broadcast('resDataUpdate',
        {
          widget: 'driverWrkHrsWidget',
          activeTab: 0,
          dashboardName: 'dashboard.driverWrkHrsDashboard',
          timespan: new Date().getTime()
        });
    });

    //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
    // Google maps takes focus if the auto refresh enabled
    // Auto refresh must be stoped if the chat window is open to solve focus switching
    var chatWindowOpenEvent = $scope.$on('chat-window-open-evt', function () {
      $scope.stopAutoRefresh(null, 'stop');
    });
    //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
    //  restart the auto refresh is the chat window is closed
    var chatWindowCloseEvent = $scope.$on('chat-window-close-evt', function () {
      $scope.stopAutoRefresh(null, 'start');
    });

    $scope.$on('$destroy', function () {
      if(chatWindowOpenEvent){
        chatWindowOpenEvent();
      }
      if(chatWindowCloseEvent){
        chatWindowCloseEvent();
      }
      $scope.stop();
      jobEvent();
      updateRequest();
      if ($scope.ctxMenuSettings && $scope.ctxMenuSettings.source) {
        delete $scope.ctxMenuSettings.source;
      }
      delete _contextSourceObj.dvrWrkhrsCtxSource;
      if ($scope.workingHoursListdataAdapter) {
        delete $scope.workingHoursListdataAdapter;
      }
      if ($scope.vehicleGroupSettings && $scope.vehicleGroupSettings.source) {
        delete $scope.vehicleGroupSettings.source;
      }
      if ($scope.cDayDrvrWrkHoursGridSettings && $scope.cDayDrvrWrkHoursGridSettings.source) {
        delete $scope.cDayDrvrWrkHoursGridSettings.source;
      }
      currentSelectedRowReqEvent();
      currentSelectedGroupEvent();
      destroyLastLocationCtxMenu();
    });

    function destroyLastLocationCtxMenu() {
      $('#'+$scope.uuidForElement+'_betoTrack_cDayDriverWorkingHoursDBCtx').unbind('itemclick', dvrWrkhrsContextHandler);
      $('#'+$scope.uuidForElement+'_betoTrack_cDayDriverWorkingHoursDBCtx').jqxMenu('destroy');
    }



  }).controller('DriverWorkingHoursEditCtrl', function ($scope, config, $translate, widgetSettingsCreatorService) {
    $scope.noOfGridRows = config.noOfGridRows;
    var source = [
      '5', '10', '15', '25', '50', '75', '100'
    ];

    // init DropDownList's settings object.
    $scope.noOfRowsettings =
    {
      placeHolder: $translate.instant('dashBoard.fleetManagement.vehicleList.noOfGridRows'),
      width: 200, height: 25,
      autoDropDownHeight: true,
      theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, //material, // theme: 'bootstrap',
      source: source
    };

    $scope.noOfGridOnChange = function (event) {
      config.noOfGridRows = event.args.item.value;
    };
  });



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/driverWorkingHours/driverWorkingHoursWidget.js